import Model from "src/app/core/models/model";

/**
 * Represents an Activity Master entity.
 */
export default class ActivityModel implements Model {
  id: string;
  name: string;
  code: string;
  description: string;
  status: string;
  process_id: string;
  createdby: string;
  updatedby: string;
  createdAt: Date;
  updatedAt: Date;

  constructor(init?: Partial<ActivityModel>) {
    if (init) {
      Object.assign(this, init);
    }
  }
}
